import * as React from "react";
import {Component } from "react";

import {UiState} from "../core/ui-state";
import {MapState} from "../core/map-state";
import {observer} from "mobx-react";
import {autorun} from "mobx";
import {AppState} from "../components/app/app-mobx";
import EsriGraphicsLayer from "@arcgis/core/layers/GraphicsLayer";
import {Dimmer, Loader} from "semantic-ui-react";
import {MapViewerConfiguration} from "../config/map-viewer-configuration";
import {NavigationConfiguration} from "../config/navigation-configuration";
import {AppConfiguration} from "../core/config/app-configuration";

import {ProjectDetails} from "./projects/project-details";
import {ProjectList} from "./projects/project-list";
import {Auftragsverwaltung, EditingObjectType} from "../stores/auftragsverwaltung-mobx";
import {Project} from "../models/project";
import {ContractorList} from "./contractors/contractor-list";
import {ContractorDetails} from "./contractors/contractor-details";
import {JournalList} from "./journal/journal-list";
import {MapButtons} from "../components/app/map-buttons/map-buttons";
import {Contractor} from "../models/contractor";

export interface AuftragsverwaltungRouterProps {
    view: __esri.MapView | __esri.SceneView | undefined;
    auftragsverwaltung: Auftragsverwaltung;
    appStore: AppState;
    uiStore: UiState;
    mapStore: MapState;
    mapViewerConfig: MapViewerConfiguration;
    appConfig: AppConfiguration;
}

@observer
export class AuftragsverwaltungRouter extends Component<AuftragsverwaltungRouterProps, any> {
    watchHandles: any[] = [];
    autorunDisposers: any[] = [];
    highlightLayers: EsriGraphicsLayer[] = [];
    constructor(props: AuftragsverwaltungRouterProps) {
        super(props);
        this.state = {
            loading: false,
            featureGraphic: null,
            highlightedItemId: null
        };
        this.highlightLayers.push(new EsriGraphicsLayer({listMode: "hide", title: "highlightLayer 1"}));
        this.highlightLayers.push(new EsriGraphicsLayer({listMode: "hide", title: "highlightLayer 2"}));
        this.highlightLayers.push(new EsriGraphicsLayer({listMode: "hide", title: "highlightLayer 3"}));

        this.goToProject = this.goToProject.bind(this);
        this.goToContractor = this.goToContractor.bind(this);
    }

    errorAndNotFound(type: EditingObjectType): void {
        const {appStore} = this.props;
        const breadcrumbs = new NavigationConfiguration();
        let errorTitle: string;
        let breadcrumbTitle: string;
        switch (type) {
        case "project":
            errorTitle = "Projekt nicht gefunden!";
            breadcrumbTitle = "Projekte";
            break;
        case "contractor":
            errorTitle = "Auftragnehmer nicht gefunden!";
            breadcrumbTitle = "Auftragnehmer";
            break;
        default:
            errorTitle = "Objekt nicht gefunden!";
            breadcrumbTitle = "Objekt";
        }
        // if (auftragsverwaltung.status !== "not-found") {
        //     errorTitle = "Es ist ein Fehler aufgetreten!";
        // }
        breadcrumbs.items = [
            { title: breadcrumbTitle }
        ];
        appStore.setPageTitle(errorTitle);
        appStore.setTopContent(null);
        appStore.setBottomContent(null);
        appStore.setAsideContent(null);
        appStore.setBreadcrumbs(breadcrumbs);
        appStore.setTopicById(type);
    }

    /**
     * Handle trigger actions, e.g. Action Button in Popup
     *
     * @param actionId
     */
    handleTriggerAction(actionId: string): void {
        const {mapStore} = this.props;

        if (mapStore.selectedFeature !== null) {
            if (actionId === "show-project") {
                const projectId = mapStore.selectedFeature.getAttribute("PROJ_ID");
                this.showProject(projectId);
            }
            if (actionId === "gemeinde-perimeter") {
                //this.handleMunicipalityTriggerAction(mapStore.selectedFeature);
            }
        }
    }
    componentDidMount(): void {
        // rerun until map view is ready and search view model is loaded
        this.autorunDisposers.push(autorun((innerReaction: any) => {
            const {view} = this.props;
            // const {objectId, topic} = this.props.appStore;
            if (!view) {
                return;
            }

            this.highlightLayers.forEach((highlightLayer) => { view.map.add(highlightLayer); });

            // TODO: Bei nächsten API Update überprüfen ob es wieder mit der ESRI trigger-action funktioniert
            // popup.popup.viewModel.on("trigger-action", (event: any) => {
            window.addEventListener("geo-trigger-action", (event: any) => {
                const actionId = event.detail.id; // event.action.id
                this.handleTriggerAction(actionId);
            });
            // if (typeof objectId !== "undefined") {
            //     if (topic.id === "projects") {
            //         auftragsverwaltung.requestProject(objectId);
            //     } else if (topic.id === "contractors") {
            //         auftragsverwaltung.requestContractor(objectId);
            //     }
            // }
            innerReaction.dispose();
        }));
    }

    componentWillUnmount(): void {
        const {view} = this.props;
        this.watchHandles.forEach((handle: any) => {
            handle.remove();
        });
        this.watchHandles.length = 0;
        if (!view) {
            return;
        }
        this.autorunDisposers.forEach((dispose: any) => {
            dispose();
        });
        this.autorunDisposers.length = 0;
        this.highlightLayers.forEach((highlightLayer) => {
            highlightLayer.removeAll();
            view.map.remove(highlightLayer);
        });
    }
    render(): React.ReactElement | null {
        const { featureGraphic } = this.state;
        const { appStore, mapStore, appConfig, mapViewerConfig, auftragsverwaltung, uiStore, view } = this.props;

        let content: React.ReactElement | null = null;
        if (!auftragsverwaltung.isEditingPerimeter) {
            if (appStore.objectId) {
                // object selected --> detailed view
                if (appStore.topic?.id === "projectsGk" || appStore.topic?.id === "projectsR") {
                    content = (<ProjectDetails
                        key={(auftragsverwaltung.ProjectStore.selectedItem as Project)?.id}
                        view={view}
                        auftragsverwaltung={auftragsverwaltung}
                        project={auftragsverwaltung.selectedProject}
                        appStore={appStore}
                        mapStore={mapStore}
                        handleErrorAndNotFound={() => this.errorAndNotFound("project")}
                        mapViewerConfig={mapViewerConfig}
                        appConfig={appConfig}/>);
                } else if (appStore.topic?.id === "contractors") {
                    content = (<ContractorDetails
                        key={(auftragsverwaltung.ContractorStore.selectedItem as Contractor)?.id}
                        view={view}
                        auftragsverwaltung={auftragsverwaltung}
                        appStore={appStore}
                        mapStore={mapStore}
                        handleErrorAndNotFound={() => this.errorAndNotFound("contractor")}
                        mapViewerConfig={mapViewerConfig}
                        appConfig={appConfig}/>);
                }
            } else {
                // no object selected --> list view
                if (appStore.topic?.id === "projectsGk") {
                    content = (<ProjectList
                        key="projects"
                        projectType="GK"
                        auftragsverwaltung={auftragsverwaltung}
                        appStore={appStore}
                        mapViewerConfig={mapViewerConfig} />);
                } else if (appStore.topic?.id === "projectsR") {
                    content = (<ProjectList
                        key="projects"
                        projectType="RISK"
                        auftragsverwaltung={auftragsverwaltung}
                        appStore={appStore}
                        mapViewerConfig={mapViewerConfig} />);
                } else if (appStore.topic?.id === "contractors") {
                    content = (<ContractorList
                        key="contractors"
                        view={view}
                        auftragsverwaltung={auftragsverwaltung}
                        appStore={appStore}
                        mapStore={mapStore}
                        mapViewerConfig={mapViewerConfig}
                        appConfig={appConfig}/>);
                } else if (appStore.topic?.id === "journal") {
                    content = (<JournalList
                        key="journal"
                        view={view}
                        appStore={appStore}
                        auftragsverwaltung={auftragsverwaltung}
                        goToProject={this.goToProject}
                        goToContractor={this.goToContractor}/>);
                }
            }
        }
        return(
            <div className="thematic-result">
                {auftragsverwaltung.loading &&
                    <Dimmer active inverted>
                        <Loader inverted>Loading</Loader>
                    </Dimmer>
                }
                <MapButtons
                    appStore={appStore}
                    auftragsverwaltung={auftragsverwaltung}
                    featureGraphic={featureGraphic}
                    uiStore={uiStore}
                    view={view}
                />

                {content}
            </div>
        );
    }

    private showProject(projectId: number): void {
        const {auftragsverwaltung, appStore, uiStore} = this.props;
        if (!projectId) {
            return;
        }

        auftragsverwaltung.ProjectStore?.loadItem(Number(projectId)).then((project: Project) =>{
            auftragsverwaltung.setShowMap(false);
            appStore.setObjectId(String(projectId));
            if (project.typeId === 4) {
                appStore.setTopicById("projectsR");
            } else {
                appStore.setTopicById("projectsGk");
            }
            uiStore.setPopupVisible(false);
        }).catch((error) => {
            console.error(`Error loading project item ${projectId}: ${error}`);
        });
    }

    private goToProject(project: Project): void {
        const {auftragsverwaltung, appStore, mapViewerConfig} = this.props;
        if (!project?.id) {
            return;
        }

        let route: string | undefined;
        if (project.typeId === 4) {
            route = "/risikouebersichten-projekte";
        }
        else {
            route = "/gefahrenkarten-projekte";
        }
        appStore.setRoutePath(route);
        const topic = mapViewerConfig.getTopicByRoute(route);
        if (!topic) {
            console.error(`No topic found for route ${route}`);
            return;
        }
        appStore.setTopic(topic);
        auftragsverwaltung.setShowMap(false);
        auftragsverwaltung.ProjectStore.selectedItem = project;
        appStore.setObjectId(project.id.toString());
    }

    private goToContractor(contractor: Contractor): void {
        const {auftragsverwaltung, appStore, mapViewerConfig} = this.props;
        if (!contractor?.id) {
            return;
        }

        const route = "/auftragnehmer";
        appStore.setRoutePath(route);
        const topic = mapViewerConfig.getTopicByRoute(route);
        if (!topic) {
            console.error(`No topic found for route ${route}`);
            return;
        }
        appStore.setTopic(topic);
        auftragsverwaltung.setShowMap(false);
        appStore.setObjectId(contractor.id.toString());
        auftragsverwaltung.ContractorStore.selectedItem = contractor;
    }

    // private handleMunicipalityTriggerAction(selectedMunicipality: __esri.Graphic) {
    //     const {auftragsverwaltung} = this.props;
    //
    //     // only allow when already on project
    //     if (!auftragsverwaltung.selectedProject) {
    //         // TODO: show window to select project type and create new project,
    //         //  when no project is selected?
    //         alert("Bitte zuerst ein Projekt auswählen.");
    //     }
    //     // if (!auftragsverwaltung.isEditingPerimeter) {
    //     //     alert("Bitte zuerst den Editiermodus für Perimeter starten.");
    //     // }
    //     if (auftragsverwaltung.selectedProject && auftragsverwaltung.selectedProject.isAlterable) {
    //
    //         auftragsverwaltung.setEditing(true, "perimeter");
    //         this.fetchMunicipalityFeatureWithFullGeometry(selectedMunicipality).then((municipalityFeature) => {
    //             if (municipalityFeature) {
    //                 // TODO: merge with existing perimeters? what if perimeter already present?
    //                 auftragsverwaltung.setPerimeterProposal(municipalityFeature);
    //             }
    //         });
    //     }
    // }
    //
    // private fetchMunicipalityFeatureWithFullGeometry(selectedMunicipality: __esri.Graphic): Promise<__esri.Graphic | null> {
    //     return new Promise((resolve) => {
    //         // get feature with all vertices!!!
    //         const municipalityLayer = selectedMunicipality.layer as __esri.FeatureLayer;
    //         const query = municipalityLayer.createQuery();
    //         query.returnGeometry = true;
    //         query.where = `OBJECTID = ${selectedMunicipality.attributes.objectid}`;
    //         municipalityLayer.queryFeatures(query).then((results) => {
    //             if (results?.features) {
    //                 resolve(results?.features[0]);
    //                 return;
    //             }
    //             resolve(null);
    //         });
    //     });
    // }
}
